import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumbs = ({ items = [] }) => (
  <nav data-testid="breadcrumbs" className="flex flex-wrap items-center gap-1.5 text-xs text-brand-muted">
    <Link to="/" className="hover:text-brand-blue">Home</Link>
    {items.map((it, i) => (
      <span key={i} className="flex items-center gap-1.5">
        <ChevronRight className="h-3 w-3 opacity-50" />
        {it.to ? (
          <Link to={it.to} className="hover:text-brand-blue">{it.label}</Link>
        ) : (
          <span className="text-brand-ink">{it.label}</span>
        )}
      </span>
    ))}
  </nav>
);
